module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1MU87"))).then(() => parcelRequire('f4eak'));